import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './CommonStyles.css';
import './Products.css'; // Reuse Product styles for layout, tabs, and tables
import './ProductsActions.css'; // Reuse Product action styles
import './MobileResponsive.css';

import Customers from './Customers';
import Suppliers from './Suppliers';
import CustomerGroups from './CustomerGroups';
import ImportContacts from './ImportContacts';

const Contacts = ({ activeTab: propActiveTab }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(propActiveTab || location.state?.activeTab || 'suppliers');
  const [showFilters, setShowFilters] = useState(false);
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState(''); // Lifted search state

  // Synchronize state with prop changes
  useEffect(() => {
    if (propActiveTab) {
      setActiveTab(propActiveTab);
    }
  }, [propActiveTab]);

  // Handle navigation state changes (e.g. returning from AddSupplier)
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  // Reset filters and search when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilterStatus('all');
    setSearchTerm('');
  };

  return (
    <div className="products-container">
      {/* Main Card: Content only (tabs moved to sidebar) */}
      <div className="main-card">
        {/* Content Area */}
        <div className="contacts-content">
          {activeTab === 'customers' && <Customers isActive={activeTab === 'customers'} filterStatus={filterStatus} searchTerm={searchTerm} onSearchChange={setSearchTerm} onShowFilters={() => setShowFilters(true)} />}
          {activeTab === 'suppliers' && <Suppliers isActive={activeTab === 'suppliers'} filterStatus={filterStatus} searchTerm={searchTerm} onSearchChange={setSearchTerm} onShowFilters={() => setShowFilters(true)} />}
          {activeTab === 'customer_groups' && <CustomerGroups isActive={activeTab === 'customer_groups'} searchTerm={searchTerm} onSearchChange={setSearchTerm} onShowFilters={() => setShowFilters(true)} />}
          {activeTab === 'import_contacts' && <ImportContacts isActive={activeTab === 'import_contacts'} />}
        </div>
      </div>

      {/* Filter Modal Popup */}
      {showFilters && (
        <div className="modal-overlay" onClick={() => setShowFilters(false)}>
          <div className="modal-container filter-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', width: '95%' }}>
            <div className="modal-header">
              <h2>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '0.5rem', verticalAlign: 'middle' }}>
                  <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                </svg>
                Filters
              </h2>
              <button className="modal-close-btn" onClick={() => setShowFilters(false)}>✕</button>
            </div>
            <div className="modal-content" style={{ padding: '2rem 1.5rem' }}>
                {activeTab === 'customers' && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem 1rem' }}>
                        {/* Checkboxes Row */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="c_sellDue" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="c_sellDue" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Sell Due</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="c_sellReturn" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="c_sellReturn" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Sell Return</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="c_advBal" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="c_advBal" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Advance Balance</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="c_openBal" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="c_openBal" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Opening Balance</label>
                        </div>

                        {/* Selects Row */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a' }}>Has no sell from:</label>
                            <select style={{ padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', color: '#475569', backgroundColor: '#fff', cursor: 'pointer', outline: 'none' }}>
                                <option>Please Select</option>
                                <option>1 Month</option>
                                <option>3 Months</option>
                                <option>6 Months</option>
                                <option>1 Year</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a' }}>Customer Group:</label>
                            <select style={{ padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', color: '#475569', backgroundColor: '#fff', cursor: 'pointer', outline: 'none' }}>
                                <option>None</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a' }}>Assigned to:</label>
                            <select style={{ padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', color: '#475569', backgroundColor: '#fff', cursor: 'pointer', outline: 'none' }}>
                                <option>None</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a' }}>Status:</label>
                            <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} style={{ padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', color: '#475569', backgroundColor: '#fff', cursor: 'pointer', outline: 'none' }}>
                                <option value="all">None</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </div>
                    </div>
                )}
                
                {activeTab === 'suppliers' && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem 1rem' }}>
                        {/* Checkboxes Row */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="s_purchDue" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="s_purchDue" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Purchase Due</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="s_purchRet" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="s_purchRet" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Purchase Return</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="s_advBal" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="s_advBal" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Advance Balance</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                            <input type="checkbox" id="s_openBal" style={{ width: '16px', height: '16px', accentColor: '#3b82f6', cursor: 'pointer' }} />
                            <label htmlFor="s_openBal" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a', cursor: 'pointer' }}>Opening Balance</label>
                        </div>

                        {/* Selects Row */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a' }}>Assigned to:</label>
                            <select style={{ padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', color: '#475569', backgroundColor: '#fff', cursor: 'pointer', outline: 'none' }}>
                                <option>None</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0f172a' }}>Status:</label>
                            <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} style={{ padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', color: '#475569', backgroundColor: '#fff', cursor: 'pointer', outline: 'none' }}>
                                <option value="all">None</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </div>
                    </div>
                )}
                
                {activeTab !== 'customers' && activeTab !== 'suppliers' && (
                    <div style={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic', padding: '1rem' }}>
                        No filters available for this section.
                    </div>
                )}
            </div>
            <div className="modal-footer">
              <button className="modal-btn close-btn" onClick={() => setShowFilters(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contacts;
